import { makeStyles } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { useUserRights } from "../../../contexts/UserRightsContext";
import AgentsList from "../../AgentsList";
import PlayerList from "../../PlayerList";
import AgentHierarchy from "./AgentHierarchy";
import AgentNotes from "./AgentNotes";
import AgentPayment from "./AgentPayment";
import AgentPersonalInfo from "./AgentPersonalInfo";
import AgentRights from "./AgentRights";
import AgentSettings from "./AgentSettings";
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>{children}</Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function AgentTabs(props) {
  const classes = useStyles();
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { data: rights } = useUserRights();
  const hasRights = (...ids) => rights && ids.some((id) => rights.includes(id));
  const { AgentInfo, getAgentStatistics, getAgentInfo } = props;
  const agentId = AgentInfo?.idAgent;

  return (
    <div className={classes.root}>
      {AgentInfo && (
        <>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            className="w-full mb-2 overflow-x-scroll tabs-class"
          >
            <Tab label="Settings" {...a11yProps(0)} />
            <Tab label="Players" {...a11yProps(1)} />
            <Tab label="Agents" {...a11yProps(2)} />
            <Tab label="Personal Information" {...a11yProps(3)} />
            <Tab label="Notes" {...a11yProps(4)} />
            <Tab label="Rights" {...a11yProps(5)} />
            <Tab label="Hierarchy" {...a11yProps(6)} />
            <Tab
              label="Payment"
              {...a11yProps(7)}
              hidden={!hasRights(24, 25, 26, 36)}
            />
          </Tabs>
          <hr className="my-2" />
          {value === 0 && (
            <TabPanel className="tab-content" value={value} index={0}>
              <AgentSettings
                AgentInfo={AgentInfo}
                getAgentInfo={getAgentInfo} />
            </TabPanel>
          )}
          {value === 1 && (
            <TabPanel value={value} index={1}>
              <PlayerList
                IdAgent={agentId}
                IdCurrency={AgentInfo.idCurrency}
                AgentName={AgentInfo.name}
              />
            </TabPanel>
          )}
          {value === 2 && (
            <TabPanel className="tab-content" value={value} index={2}>
              <AgentsList IdAgent={agentId} />
            </TabPanel>
          )}
          {value === 3 && (
            <TabPanel className="tab-content" value={value} index={3}>
              <AgentPersonalInfo
                AgentInfo={AgentInfo}
                getAgentInfo={getAgentInfo}
              />
            </TabPanel>
          )}
          {value === 4 && (
            <TabPanel className="tab-content" value={value} index={4}>
              <AgentNotes IdAgent={agentId} />
            </TabPanel>
          )}
          {value === 5 && (
            <TabPanel className="tab-content" value={value} index={5}>
              <AgentRights IdAgent={agentId} />
            </TabPanel>
          )}
          {value === 6 && (
            <TabPanel className="tab-content" value={value} index={6}>
              <AgentHierarchy IdAgent={agentId} />
            </TabPanel>
          )}
          {value === 7 && (
            <TabPanel className="tab-content" value={value} index={7}>
              <AgentPayment
                IdAgent={agentId}
                getAgentStatistics={getAgentStatistics}
              />
            </TabPanel>
          )}
        </>
      )}
    </div>
  );
}
